// extracted by mini-css-extract-plugin
export default {"title":"_5ff4abe8"};